import { CustomTooltip } from '@cian/ui-kit';

import * as React from 'react';

interface IDropdownProps {
  children: React.ReactNode;
  opened: boolean;
  anchorRef: React.RefObject<HTMLElement | null>;
}

export const Dropdown: React.FC<IDropdownProps> = props => {
  const { opened, anchorRef, children } = props;

  if (!opened) {
    return null;
  }

  return (
    <CustomTooltip
      anchorRef={anchorRef}
      content={children}
      maxWidth={350}
      open={opened}
      placement="bottom-start"
      portal={false}
    />
  );
};

Dropdown.displayName = 'Dropdown';
